import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed w-full bg-navy-800/95 backdrop-blur-sm z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <div className="flex items-center gap-3">
              <img
                src={`${process.env.PUBLIC_URL}/logo-icon.png`}
                alt="Global Digital Print"
                className="h-10 w-auto"
              />
              <img
                src={`${process.env.PUBLIC_URL}/logo-text.png`}
                alt="Global Digital Print"
                className="h-8 w-auto filter brightness-0 invert"
              />
            </div>
          </div>

          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <button onClick={() => scrollToSection('home')} className="text-silver-200 hover:text-silver-50 px-3 py-2 transition-colors">
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className="text-silver-200 hover:text-silver-50 px-3 py-2 transition-colors">
                About
              </button>
              <button onClick={() => scrollToSection('products')} className="text-silver-200 hover:text-silver-50 px-3 py-2 transition-colors">
                Products
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-silver-200 hover:text-silver-50 px-3 py-2 transition-colors">
                Testimonials
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-silver-200 hover:text-silver-50 px-3 py-2 transition-colors">
                Contact
              </button>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-silver-200 hover:text-silver-50"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-navy-700">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <button onClick={() => scrollToSection('home')} className="text-silver-200 hover:text-silver-50 block px-3 py-2 w-full text-left">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-silver-200 hover:text-silver-50 block px-3 py-2 w-full text-left">
              About
            </button>
            <button onClick={() => scrollToSection('products')} className="text-silver-200 hover:text-silver-50 block px-3 py-2 w-full text-left">
              Products
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-silver-200 hover:text-silver-50 block px-3 py-2 w-full text-left">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-silver-200 hover:text-silver-50 block px-3 py-2 w-full text-left">
              Contact
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
